import React from 'react';
import { Col } from 'antd';

import pjLogo from 'assets/images/pjLogo.svg';
import { UserMenuButtonComponent } from 'components/UserMenuButtonComponent';

import 'components/Header/header.scss';
import { NavLink } from 'react-router-dom';

interface Props {
  showMenu?: boolean;
  backgroundAccent?: boolean;
}

export const Header: React.FC<Props> = ({
  showMenu = true,
  backgroundAccent = true,
}) => {
  return (
    <div className={`${backgroundAccent ? 'backgroundAccent' : ''}`}>
      <Col md={{ pull: 1, push: 1, span: 22 }} className='header-wrapper'>
        <Col md={2} className='left-column' />
        <Col md={20} className='center-column'>
          <NavLink to='/home'>
            <img src={pjLogo} alt='Papa Johns logo' />
          </NavLink>
        </Col>
        <Col md={2} className='right-column'>
          {showMenu && <UserMenuButtonComponent />}
        </Col>
      </Col>
    </div>
  );
};
